import React from 'react';
import Component from '../component/Component';
import ProgressBar from './ProgressBar';
import _ from 'lodash';
import { PROGRESS_BAR_STATE, ProgressType } from './Types';

class ProgressBarHolder extends Component<{}, PROGRESS_BAR_STATE> {
  updateProgress = (progresses: ProgressType) => {
    this.setState({
      progresses: _.merge(this.state.progresses || {}, progresses)
    });
  };

  renderBody(): any {
    const { progresses = {} } = this.state;
    const items = Object.keys(progresses).map((uploadGroupId: string) => (
      <div id={`ProgressBar_${uploadGroupId}`}>
        <div id={`ProgressBar_${uploadGroupId}_text`}>{uploadGroupId}:</div>
        {
          Object.keys(progresses[uploadGroupId]).map((fileName: string) => (
            <ProgressBar
              key={`ProgressBar_${uploadGroupId}_${fileName}`}
              group={uploadGroupId}
              fileName={fileName}
              progresses={progresses[uploadGroupId]}
              showFileName={true}
              progressLabelPosition={'none'}
            />))
        }
      </div>
    )
    );
    return (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <span>{this.translate('minutesLeft', { numberOfMinutes: 10 })}</span>
        </div>
        {items}
      </>
    );
  }
}

export default ProgressBarHolder;
